import React from "react"
import "./loginBtn.sass"
import classNames from "classnames"
import { defaultIntl } from "../utils"

const LoginButton = ({ styles, className, onClick, to = "/", children, intl = defaultIntl }) => {
  const handleClick = e => {
    if (typeof onClick === "function") {
      e.preventDefault()
      onClick.call(null, e)
    }
  }
  return (
    <div className="login-btn-wrapper">
      {/* {intl.formatMessage({ id: "driver.banner.login" })}
      <a href={to} target="_blank" onClick={handleClick} className={classNames("login-btn", { [className]: className })} style={{ ...styles }}>
        <i>{intl.formatMessage({ id: "driver.banner.underscoreLogin" })}</i>
      </a> */}
    </div>
  )
}

export default LoginButton
